export default {
  title: '添加服务帐号',
  menu: '添加服务帐号',
  label: {
    adminType: '管理员类型',
    hQAdmin: 'HQ Admin',
    ajingaSystemAdmin: 'Ajinga System Admin',
    emailAddress: '邮箱地址',
    companyId: '公司Id',
    note: '备注：',
    note1: 'HQ admin: 客户公司管理员，具有公司全部权限。',
    note2: 'Ajinga system admin: 菁客平台管理员，能使用“公司审核”，“收费项目设置”，“上传数据”功能。'
  },
  placeholder: {
  },
  message: {
    createAdminSuccess: '创建成功'
  }
}
